// @ts-check
import React from 'react';
import { Page, Registration, Text, Title } from '../../pdf-design-system';
import Columns from './Columns';
import { OrderedList, ListItem } from './List';
import Stack from './Stack';
import { theme } from './LKEinreichung';

export default function Terms() {
  /** @type {import('./LKEinreichung').Registration} */
  const registration = Registration.useRegistration();
  return (
    <Page theme={theme} style={{ padding: '20mm' }}>
      <Text>{registration.collection.name}</Text>

      <Stack space={3}>
        <Title>Teilnahmebedingungen</Title>
        <OrderedList format={(/** @type {number} */ number) => `${number}.`}>
          <Columns>
            <Stack>
              <ListItem variant="small">
                Zur Bgld. Weinprämierung können nur Weine, Sekte, Perlweine
                eingereicht werden, deren Trauben im Burgenland gewachsen sind.
                Tafelwein und Landwein sind von der Bgld. Weinprämierung
                ausgeschlossen.
              </ListItem>
              <ListItem variant="small">
                Zur Teilnahme sind alle Betriebe der Weinwirtschaft
                (Produzenten, Handelsbetriebe, Winzergenossenschaften)
                zugelassen.
              </ListItem>
              <ListItem variant="small">
                Zur Bgld. Weinprämierung können nur Weine jener Traubensorten
                eingereicht werden, die im Weingesetz zur Gewinnung von
                Qualitätswein oder Prädikatswein zugelassen sind, auch sonst
                müssen die eingereichten Weine inkl. Perlwein und Sekt dem
                geltenden Österr. Weingesetz entsprechen.
              </ListItem>
              <ListItem variant="small">
                Staatl. Prüfnummer: Alle Qualitätsweine und alle Prädikatsweine
                müssen den Nachweis der Zuteilung der Staatl. Prüfnummer
                erbringen. Über die im Einreichungsformular geforderten
                Bezeichnungen, Prüfnummer und analytischen Werte sind
                verbindliche Angaben zu machen. Falschangaben gelten als
                Urkundenfälschung.
              </ListItem>
              <ListItem variant="small">
                Die eingereichten Weine inkl. Perlwein und Sekt müssen zum
                Zeitpunkt der Einreichung bereits in Flaschen gefüllt sein{' '}
                <Text
                  variant="small"
                  style={{ textDecoration: 'underline', fontWeight: 'bold' }}
                >
                  und die Staatl. Prüfnummer haben.
                </Text>
              </ListItem>
              <ListItem variant="small">
                <Stack>
                  <Text variant="small">
                    Die Weine können in Flaschen der üblichen Handelsgrößen
                    (0,375 l - 1 l), Formen und Farben eingereicht werden.
                    Flaschen bis 0,5 l sind nur für höhere Prädikatsweine ab
                    Auslese zulässig. Bei 0,75 l bis 1 l Flaschen sind 2
                    Flaschen, bei 0,375 l bis 0,5 l sind 3 Flaschen Wein je
                    Sorte zur Weinprämierung anzuliefern. Die Flaschen einer
                    eingereichten Probe müssen in Größe, Form und Farbe gleich
                    sein.
                  </Text>
                  <Text>
                    <Text variant="small" style={{ backgroundColor: 'yellow' }}>
                      Ins Landessiegerstechen können nur Weine bzw.
                      Qualitätssekte gelangen, bei denen laut
                      Prüfnummernbescheid von Beerenauslese, Eiswein, Ausbruch,
                      Trockenbeerenauslese mind. 500 Flaschen und von allen
                      anderen Weinen mind. 750 Liter (1.000 Flaschen), bzw. in
                      der Kategorie Weißwein Reserve mind. 675 Liter (900
                      Flaschen), zur Verfügung stehen.
                    </Text>
                  </Text>
                </Stack>
              </ListItem>
              <ListItem variant="small">
                Weine inkl. Perlwein und Sekt, die widerrechtlich in geschützte
                Flaschen oder Ausschussflaschen abgefüllt wurden oder nur
                provisorisch verschlossen sind, werden nicht angenommen.
              </ListItem>
              <ListItem>
                <Stack>
                  <Text variant="small">
                    Die Flaschenausstattung muss mit den Angaben auf dem
                    Einreichungsformular (Name, Anschrift, Sorte, Jahrgang,
                    Leseart, Herkunft, Staatl. Prüfnummer, Alkohol- und
                    Restzuckerhinweis) in allen Details übereinstimmen und mit
                    Banderolen versehen sein.
                  </Text>
                  <Text variant="small">
                    Der Veranstalter der Bgld. Weinprämierung behält sich das
                    Recht vor, alle Angaben im Bundesamt für Weinbau
                    (stichprobenweise) zu überprüfen. Bei Angaben und Werten,
                    die in der Praxis mit jenen auf dem Einreichungsformular
                    nicht übereinstimmen, wird der Wein der Prämierung nicht
                    zugeführt.
                  </Text>
                </Stack>
              </ListItem>
            </Stack>
            <Stack>
              <ListItem variant="small">
                Weinbewertung: Die Bewertung der Weine inkl. Perlwein und Sekt
                ist durch Kostkommissionen, die sich aus fachkundigen
                KosterInnen zusammensetzen, vorgesehen. Für den Ablauf der
                Verkostung und Prämierung sind die genauen &quot;Richtlinien der
                Weinkostkommission&quot;, die auf fachliche Grundsätze aufgebaut
                sind, anzuwenden.
              </ListItem>
              <ListItem variant="small">
                Das Urteil der Kost- und Prüfungskommission ist endgültig, ein
                Einspruch gegen die Bewertung und Prämierung ist nicht möglich.
                Die Bewertung ist auch Grundlage für die Nominierung in den
                Österreichischen Weinsalon.
              </ListItem>
              <ListItem variant="small">
                Ich stimme zu, dass die Angaben EDV-mäßig verarbeitet werden.
                Der Teilnehmer räumt den Veranstaltern das Recht ein, alle
                Angaben (insbesondere beim BA Eisenstadt) hinsichtlich
                Prüfnummer zu überprüfen.
              </ListItem>
              <ListItem variant="small">
                Kennzeichnung prämierter Weine: Auf Grund der Bewertung und
                Prämierung erhält jeder Teilnehmer eine Benachrichtigung, im
                Falle einer Prämierung des Weines inkl. Perlwein und Sekt eine
                Urkunde, desgleichen einen Berechtigungsschein zum Bezug von
                Klebeetiketten in der Menge und Art, die dem jeweiligen Wein
                inkl. Perlwein und Sekt zusteht. Die Verwendung von
                Prämierungsergebnissen darf nur in einer Weise geschehen, die
                eine Irreführung des Verbrauchers ausschließt. Die offizielle
                Verlautbarung der Prämierungsergebnisse erfolgt im
                Mitteilungsblatt der Bgld. Landwirtschaftskammer oder in einer
                eigenen Publikation. Der Einreicher erklärt sich mit der
                Veröffentlichung der Ergebnisse aller prämierten Weine inkl.
                Perlwein und Sekt sowie der Speicherung der angegebenen Daten
                laut Formular für archivarische bzw. journalistische Zwecke
                einverstanden.
              </ListItem>
              <ListItem variant="small">
                Verändert sich ein prämierter Wein inkl. Perlwein und Sekt im
                Laufe der Lagerung ungünstig, so ist das Prämierungsergebnis
                hinfällig und darf nicht weiter verwendet werden.
              </ListItem>
              <ListItem variant="small">
                Sanktionen - Einziehung von Preisen: Preise und Urkunden können
                durch den Veranstalter der Bgld. Weinprämierung, wenn diese
                Bedingungen nicht eingehalten werden, eingezogen werden. Bei
                Missbrauch kann eine Verwarnung, ein Ausschluss von der Bgld.
                Weinprämierung auf Zeit oder auf Dauer ausgesprochen werden.
              </ListItem>
              <ListItem>
                <Stack>
                  <Text variant="small">
                    Durch die Unterschrift auf dem umseitigen
                    Einreichungsformular erklärt sich der Teilnehmer mit diesen
                    Bedingungen der Weinprämierung einverstanden.
                  </Text>
                  <Text variant="small">
                    Die Bedingungen für eine Teilnahme am &quot;Salon des
                    Österr. Weines&quot; hat der Teilnehmer zur Kenntnis
                    genommen und erklärt sich mit diesen Bedingungen
                    einverstanden.
                  </Text>
                </Stack>
              </ListItem>
            </Stack>
          </Columns>
        </OrderedList>
      </Stack>
    </Page>
  );
}
